import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import ApproveJobOrder from './views/ApproveJobOrder.vue'
import CheckoutSuccess from './views/CheckoutSuccess.vue'
import ManualEstimate from './views/ManualEstimate.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    //The job URLs are really legacy and aren't different than the order ones. But incase we have 
    //References elsewhere they can stay but should probably be removed in the future.
    {
      path: '/job/:id/success',
      name: 'Order Success',
      component: CheckoutSuccess,
      props: true
    },
    {
      path: '/job/:id',
      name: 'Job Page',
      component: Home,
      props: true
    },
    {
      path: '/order/:id/success',
      name: 'Order Success',
      component: CheckoutSuccess,
      props: true
    },
    {
      path: '/order/:id',
      name: 'Order Job',
      component: Home,
      props: true
    },
    {
      path: '/order/:orderStatus/:id',
      name: 'Order Status',
      component: Home,
      props: true
    },
    {
      path: '/approve-job-order/:id',
      name: 'Approve Job',
      component: ApproveJobOrder,
      props: true
    },
		{
			path: '/manual-estimate/:id',
			name: 'Manual Estimate',
			component: ManualEstimate,
			props: true
		},
    {
      path: '/*',
      redirect: '/',
    }
  ]
})
